import ComponentsFactory from 'foundation/components-factory';
import TicketResaleBannerComponent from './js/ticket-resale-banner.component';

ComponentsFactory.getInstance().define('ticket-resale-banner', TicketResaleBannerComponent);
